module.exports = __webpack_public_path__ + "static/media/fail-kk.cafc1e7c.png";